export default __webpack_public_path__ + "static/media/backArrow.5e30a30b.svg";